import { memo } from 'react';
import { StepViewComponentProps } from '../stepDescriptor/types';
import ModelResponseEditorTaskComponent from './ModelResponseEditorTaskComponent';
import { useStepParams } from 'react-scale/components/scalers/tasks/Chat/hooks/ChatStore.hooks';
import { InteractionStepType } from '@scale/shared/types/chat/params';
import NativeToolCallEditorTaskComponent from 'react-scale/components/scalers/tasks/ThreadedInteraction/definitions/ModelResponseEditor/NativeToolCallEditor/NativeToolCallEditorTaskComponent';

export const ModelResponseEditorViewComponent = memo(
  ({ responseIndex, complete, readOnly }: StepViewComponentProps) => {
    const stepParams = useStepParams<InteractionStepType.ModelResponseEditor>(responseIndex);
    return (
      <>
        {stepParams.params.use_tool_call_editor ? (
          <NativeToolCallEditorTaskComponent
            responseIndex={responseIndex}
            complete={complete}
            readOnly={readOnly}
            isPinnedView={false}
            isPinnable
          />
        ) : (
          <ModelResponseEditorTaskComponent
            responseIndex={responseIndex}
            complete={complete}
            readOnly={readOnly}
            isPinnedView={false}
            isPinnable
          />
        )}
      </>
    );
  },
);
